/**
 * Query-backed tile kebab items (S11): "Open query in editor" (with active
 * cross-filter provenance when the tile is filtered) and "Open execution
 * plan" (G10 — a query tab + queued estimated-plan run).
 */
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useAnalytics } from '@/core/analytics/useAnalytics';
import { getEngineForConnection } from '../../../../connections/utils/connectionLookup';
import { relevantFiltersForTile } from '../../services/crossFilter';
import { openTileExecutionPlan, openTileInQueryEditor } from '../../services/tileNavigation';
import type { QueryBackedTile } from '../../services/tileExecutionService';
import {
  selectActiveFilters,
  useDashboardCrossFilterStore,
} from '../../store/dashboardCrossFilterStore';

export function TileQueryMenuItems({
  dashboardId,
  tile,
}: {
  dashboardId: string;
  tile: QueryBackedTile;
}) {
  const { track } = useAnalytics();

  const openQuery = () => {
    const engine = getEngineForConnection(tile.connectionId);
    const active = selectActiveFilters(dashboardId)(useDashboardCrossFilterStore.getState());
    openTileInQueryEditor(tile, relevantFiltersForTile(tile, active, engine), engine);
    track('feature:dashboard_tile_open_query', { engine });
  };

  const openPlan = () => {
    openTileExecutionPlan(tile);
    track('feature:dashboard_tile_open_plan', { engine: getEngineForConnection(tile.connectionId) });
  };

  return (
    <>
      <DropdownMenuItem onClick={openQuery} data-testid="tile-open-query-item">
        Open query in editor
      </DropdownMenuItem>
      <DropdownMenuItem onClick={openPlan} data-testid="tile-open-plan-item">
        Open execution plan
      </DropdownMenuItem>
    </>
  );
}
